import payments from '../api/payments';

export default {
  state: {
    payments: {
      data: [],
      count: 0
    },
    methods: {
      data: [],
      count: 0
    },
    paymentsCalculations:[],
    updatedPaymentsCount: 0
  },
  namespaced: true,
  mutations: {
    async savePaymentsStore(state, payments) {
      state.payments = payments;
    },
    async savePaymentsCalculationsStore(state, paymentsCalculations) {
      state.paymentsCalculations = paymentsCalculations;
    },
    async updatePaymentStore(state, payment) {
      const index = state.payments.data.findIndex((p) => p.id === payment.id);
      if (index !== undefined) {
        const data = [...state.payments.data];
        data.splice(index, 1);
        state.payments = Object.assign(state.payments, {data});
      }
    },
    async massUpdatePaymentStore(state, payment) {
      state.updatedPaymentsCount = payment.length;
    },
    async saveMethodsStore(state, methods) {
      state.methods = methods;
    },
    async saveMethodStore(state, method) {
    },
    async updateMethodStore(state, method) {
      const data = [...state.methods.data];
      const updatedMethod = method.data;
      const index = state.methods.data.findIndex(m => m.id === updatedMethod.id);
      if (index !== -1) {
        data[index] = updatedMethod;
      }
      state.methods.data = [...data]
    },
  },
  actions: {
    async getPayments({commit, dispatch}, data) {
      commit('savePaymentsStore', await payments.getPayments(data))
    },
    async getPaymentsCalculations({commit, dispatch}, data) {
      commit('savePaymentsCalculationsStore', await payments.getPaymentsCalculations(data))
    },
    async updatePayment({commit, dispatch}, data) {
      commit('updatePaymentStore', await payments.updatePayment(data))
    },
    async massUpdatePayments({commit, dispatch}, data) {
      commit('massUpdatePaymentStore', await payments.massUpdatePayments(data))
    },
    async getMethods({commit, dispatch}, data) {
      commit('saveMethodsStore', await payments.getMethods(data))
    },
    async saveMethod({commit, dispatch}, data) {
      commit('saveMethodStore', await payments.saveMethod(data))
    },
    async updateMethod({commit, dispatch}, data) {
      commit('updateMethodStore', await payments.updateMethod(data))
    },
  },
  getters: {
    payments: state => state.payments,
    paymentsCalculations: state => state.paymentsCalculations,
    methods: state => state.methods,
    updatedPaymentsCount: state => state.updatedPaymentsCount
  }
};
